import { render, staticRenderFns } from "./TextContentBlock.vue?vue&type=template&id=317bf70b&scoped=true&"
import script from "./TextContentBlock.vue?vue&type=script&lang=js&"
export * from "./TextContentBlock.vue?vue&type=script&lang=js&"
import style0 from "./TextContentBlock.vue?vue&type=style&index=0&id=317bf70b&lang=scss&scoped=true&"
import style1 from "./TextContentBlock.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317bf70b",
  null
  
)

export default component.exports